import { render, staticRenderFns } from "./changeGoods.vue?vue&type=template&id=15a75965&scoped=true&"
import script from "./changeGoods.js?vue&type=script&lang=js&"
export * from "./changeGoods.js?vue&type=script&lang=js&"
import style0 from "./changeGoods.styl?vue&type=style&index=0&id=15a75965&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a75965",
  null
  
)

export default component.exports